{
  "fr": {
    "timetable": {
      "headline": "Organisez votre quotidien scolaire",
      "today": "Aujourd'hui",
      "month": "Mois",
      "week": "Semaine",
      "day": "Jour",
      "weekNumberFormat": "(Semaine {weekNumber})",
      "dayFormat": "{day}, {date}",
      "previous": "Retour",
      "next": "Suivant",
      "defaultCalendarTitle": "Mon emploi du temps",
      "calendar": "Emploi du temps",
      "createNewTimetable": "Créer un nouvel emploi du temps",
      "settings": "Paramètres",
      "lastSynced": "Dernière synchronisation :",
      "breakTimeTooltip": "Aucune heure de cours affichée pendant les périodes sans cours.",
      "untisSyncedTooltip": "Calendrier synchronisé depuis Untis",
      "sync": {
        "chip": {
          "syncing": "Emploi du temps en cours de synchronisation"
        },
        "toast": {
          "initialSyncing": {
            "title": "Emploi du temps en cours de synchronisation",
            "body": "Cela peut prendre un moment. Vous pouvez laisser la page ouverte — les rendez-vous apparaîtront automatiquement une fois la synchronisation terminée."
          },
          "success": "Emploi du temps synchronisé avec succès",
          "errorAuthExpired": "Connexion à WebUntis expirée. Veuillez reconnecter votre compte.",
          "errorNotConnected": "Aucun compte WebUntis connecté",
          "errorNotFound": "Année scolaire introuvable dans WebUntis",
          "errorGeneric": "Impossible de synchroniser l'emploi du temps pour le moment"
        }
      },
      "offcanvas": {
        "title": "Paramètres",
        "untisHint": {
          "title": "Emploi du temps WebUntis",
          "description": "Ce calendrier est {highlightSync} avec votre emploi du temps WebUntis.",
          "highlightSync": "synchronisé automatiquement",
          "bullet1": "Sur WebUntis, vous pouvez {highlightBullet1}.",
          "highlightBullet1": "modifier ou déplacer des rendez-vous",
          "bullet2": "Dans l'emploi du temps fobizz, vous pouvez {highlightBullet2}.",
          "highlightBullet2": "planifier des cours"
        },
        "webuntisTip": {
          "title": "Conseil pour les écoles WebUntis",
          "linkText": "fobizz.com/untis-plattform"
        },
        "sections": {
          "basicSettings": {
            "title": "Paramètres de base",
            "dateRangeLabel": "Période",
            "dateRange": "Du {startDate} au {endDate}",
            "calendarName": "Nom",
            "lessonDuration": "Durée d'une heure de cours",
            "lessonDurationOption": "{duration} min.",
            "deleteTimetable": "Supprimer l'emploi du temps",
            "validation": {
              "nameRequired": "Veuillez entrer un nom.",
              "durationRequired": "Veuillez choisir une durée de cours."
            }
          },
          "breakTimes": {
            "title": "Vacances & périodes sans cours",
            "addButton": "Ajouter une nouvelle période de vacances",
            "editEntry": "Modifier l'entrée",
            "deleteEntry": "Supprimer l'entrée",
            "loading": "Chargement des périodes de vacances...",
            "alertTitle": "Bon à savoir :",
            "alertDescription": "Pendant les vacances, aucun cours n'est affiché dans votre emploi du temps."
          },
          "courses": {
            "title": "Mes cours",
            "addCourseButton": "Ajouter un nouveau cours",
            "editCourse": "Modifier le cours",
            "deleteCourse": "Supprimer le cours",
            "emptyState": {
              "headline": "Créez votre premier cours maintenant",
              "description": "Avec vos cours, vous pouvez remplir votre emploi du temps.",
              "addButton": "Ajouter un cours"
            },
            "loading": "Chargement des cours..."
          }
        },
        "flash": {
          "updateSuccess": "Paramètres enregistrés avec succès",
          "updateFailed": "Erreur lors de l'enregistrement des paramètres"
        }
      },
      "colors": {
        "label": "Couleur du cours",
        "yellow": "Jaune",
        "orange": "Orange",
        "red": "Rouge",
        "magenta": "Magenta",
        "green": "Vert",
        "teal": "Turquoise",
        "cyan": "Cyan",
        "patrol": "Patrol",
        "purple": "Violet",
        "purpur": "Pourpre",
        "gray": "Gris"
      },
      "errors": {
        "failedToLoadEvent": "Impossible de charger le rendez-vous",
        "failedToSaveEvent": "Le rendez-vous n'a pas pu être enregistré"
      },
      "validation": {
        "titleMaxLength": "Le titre ne doit pas dépasser {max} caractères",
        "courseNameMaxLength": "Le nom du cours ne doit pas dépasser {max} caractères"
      },
      "create": {
        "headline": "Créer un nouvel emploi du temps",
        "form": {
          "titleLabel": "Titre",
          "namePlaceholder": "Saisir un titre...",
          "dateRangeLabel": "Date de début et de fin",
          "dateFromLabel": "De",
          "dateToLabel": "À",
          "submitting": "Création de l'emploi du temps..."
        },
        "validation": {
          "titleRequired": "Veuillez entrer un nom",
          "startDateRequired": "Veuillez choisir une date de début",
          "invalidStartDate": "Veuillez entrer une date de début valide",
          "endDateRequired": "Veuillez choisir une date de fin",
          "invalidEndDate": "Veuillez entrer une date de fin valide",
          "endDateAfterStart": "La date de fin doit être postérieure ou égale à la date de début"
        },
        "flash": {
          "created": "Emploi du temps créé avec succès",
          "createFailed": "Erreur lors de la création de l'emploi du temps"
        }
      },
      "createForm": {
        "nameLabel": "Nom de l'emploi du temps",
        "namePlaceholder": "p. ex. Année scolaire 2026/27…",
        "startDateLabel": "Date de début",
        "endDateLabel": "Date de fin",
        "teachingWeeks": "{count} semaine de cours | {count} semaines de cours",
        "locationLabel": "Lieu de l'école",
        "international": "International",
        "changeSchool": "Modifier",
        "changeSchoolAriaLabel": "Changer d'école",
        "schoolsLoadFailed": "Impossible de charger vos écoles. Sans elles, l'emploi du temps ne peut pas encore être créé.",
        "holidaysHint": "Les vacances et jours fériés sont automatiquement repris dans votre emploi du temps."
      },
      "createChoice": {
        "manual": {
          "title": "Créer son propre emploi du temps",
          "text": "Nommer la période, puis saisir les heures vous-même.",
          "button": "Créer soi-même"
        },
        "or": "ou",
        "untis": {
          "title": "Votre école utilise-t-elle WebUntis ?",
          "text": "Avec une liaison, votre emploi du temps apparaît automatiquement dans fobizz. Vos heures sont reprises – sans effort, et même en cas de modifications ultérieures.",
          "bulletAutomatic": "Les heures, classes et salles proviennent automatiquement de WebUntis.",
          "bulletAdmin": "Requis une seule fois : l'administrateur WebUntis de votre école active la connexion.",
          "infoButton": "Informations générales",
          "dismissButton": "Ne plus afficher ce message"
        }
      },
      "createEvent": {
        "title": "Créer un nouveau rendez-vous",
        "courseLabel": "Créer un rendez-vous pour :",
        "courseSelection": {
          "placeholder": "Sélectionner...",
          "newCourse": "Nouveau cours",
          "otherEvent": "Autre rendez-vous",
          "selectCourse": "Sélectionner un cours",
          "loading": "Chargement des cours...",
          "courses": "Cours",
          "courseSectionLabel": "Heure de cours dans le cours",
          "otherEventSectionLabel": "Autre rendez-vous"
        },
        "dateAndRecurrence": "Jour de la semaine et répétition",
        "recurrenceLabel": "Répétition",
        "recurrenceOptions": {
          "onetime": "Unique",
          "weekly": "Hebdomadaire",
          "biweekly": "Tous les deux semaines",
          "quadweekly": "Tous les 4 semaines"
        },
        "durationLabel": "Durée",
        "eventTitleLabel": "Titre du rendez-vous",
        "eventTitlePlaceholder": "Saisir un titre...",
        "courseNameLabel": "Titre du cours",
        "courseNamePlaceholder": "ex. Maths 7B",
        "courseColorLabel": "Choisir une couleur",
        "errors": {
          "endTimeBeforeStart": "L'heure de fin doit être après l'heure de début",
          "createFailed": "Erreur lors de la création du rendez-vous"
        }
      },
      "courseModal": {
        "courseNameLabel": "Nom du cours",
        "courseNamePlaceholder": "Saisir un titre...",
        "courseColorLabel": "Couleur",
        "classroomLabel": "Lier la salle de classe",
        "classroomPlaceholder": "Non lié",
        "validation": {
          "courseNameRequired": "Veuillez entrer un nom de cours"
        },
        "createCourse": {
          "title": "Créer un nouveau cours",
          "create": "Créer",
          "errors": {
            "createFailed": "Erreur lors de la création du cours"
          }
        },
        "editCourse": {
          "title": "Modifier le cours",
          "save": "Enregistrer",
          "errors": {
            "editFailed": "Erreur lors de la mise à jour du cours"
          }
        }
      },
      "deleteCourse": {
        "title": "Supprimer le cours ?",
        "message": "Attention : Si vous supprimez ce cours, tous les rendez-vous associés seront annulés (au total {count}). Êtes-vous sûr de vouloir supprimer l'ensemble du cours ?",
        "delete": "Oui, supprimer",
        "errors": {
          "deleteFailed": "Erreur lors de la suppression du cours"
        }
      },
      "breakTimeModal": {
        "titleLabel": "Titre",
        "titlePlaceholder": "Vacances d'été, vacances d'automne,...",
        "startDateLabel": "De",
        "endDateLabel": "À",
        "validation": {
          "titleRequired": "Veuillez entrer un titre",
          "startDateRequired": "Veuillez choisir une date de début",
          "endDateRequired": "Veuillez choisir une date de fin",
          "endDateMustBeAfterStartDate": "La date de fin doit être après la date de début"
        },
        "createBreakTime": {
          "title": "Ajouter des périodes sans cours",
          "success": "Période sans cours ajoutée avec succès",
          "errors": {
            "createFailed": "Erreur lors de l'ajout de la période sans cours"
          }
        },
        "editBreakTime": {
          "title": "Modifier la période sans cours",
          "success": "Période sans cours mise à jour avec succès",
          "errors": {
            "editFailed": "Erreur lors de la mise à jour de la période sans cours"
          }
        }
      },
      "deleteBreakTime": {
        "title": "Supprimer la période sans cours ?",
        "message": "L'entrée sera supprimée de votre emploi du temps.",
        "delete": "Oui, supprimer",
        "errors": {
          "deleteFailed": "Erreur lors de la suppression de la période sans cours"
        }
      },
      "deleteTimetable": {
        "title": "Supprimer l'emploi du temps ?",
        "message": "L'emploi du temps {calendarName} sera supprimé, y compris toutes les entrées.",
        "delete": "Oui, supprimer",
        "success": "Emploi du temps supprimé avec succès",
        "errors": {
          "deleteFailed": "Erreur lors de la suppression de l'emploi du temps"
        }
      },
      "lessonPlan": {
        "entryButton": "Créer un plan de cours 🤓",
        "tabsLabel": "Leçon et plan de cours",
        "lessonTab": "Leçon",
        "planTab": "Plan de cours",
        "minutes": "Min.",
        "bufferDuration": "env. {minutes} min · facultatif",
        "loadErrorTitle": "Le plan de cours n'a pas pu être chargé",
        "loadError": "Veuillez recharger la page ou réessayer plus tard.",
        "form": {
          "title": "Créer un plan de cours",
          "description": "Créez un plan de cours structuré à partir des informations de cette leçon.",
          "sourceContext": "Titre, notes et matériel",
          "instruction": "Que faut-il prendre en compte en plus ? (optionnel)",
          "instructionPlaceholder": "p. ex. travail de groupe et une brève vérification des acquis",
          "automatic": "Automatique",
          "entryType": "Type d'entrée en matière",
          "entryTypes": {
            "problem": "Orienté problème",
            "informative": "Informatif",
            "associative": "Associatif",
            "playful": "Ludique"
          },
          "lessonFocus": "Focus de la leçon",
          "lessonFocuses": {
            "presentation": "Présentation",
            "groupwork": "Travail en groupe",
            "solo_work": "Travail individuel",
            "creativity": "Créativité"
          }
        },
        "generate": "Créer un plan de cours 🤓",
        "generating": "Création du plan de cours en cours…",
        "generationError": "Le plan de cours n'a pas pu être créé. Vous pouvez réessayer.",
        "learningObjectives": "Objectifs d'apprentissage",
        "curriculum": {
          "basedOn": "Basé sur les programmes scolaires pour {place}.",
          "basedOnWithoutPlace": "Basé sur les programmes scolaires.",
          "hide": "Masquer",
          "noSubject": "Nous n'avons pas pu déduire la matière à partir du nom du cours. Nommez le cours d'après la matière, par exemple « Mathématiques 7b », et l'IA utilisera un programme scolaire lors de la prochaine ébauche.",
          "notFound": "Pour cette leçon, nous n'avons trouvé aucun programme scolaire adapté.",
          "show": "Afficher",
          "unknownRegion": "Sans Land, l'IA n'utilise aucun programme scolaire.",
          "upload": "Importer le vôtre"
        },
        "phases": "Déroulement du cours",
        "primaryActors": {
          "learners": "Apprenant·e·s",
          "mixed": "Enseignant·e et apprenant·e·s",
          "teacher": "Enseignant·e"
        },
        "description": "Description",
        "materials": "Matériel",
        "materialType": "Type de matériel",
        "selectMaterial": "Sélectionner du matériel",
        "createMaterial": "Créer du matériel",
        "materialPending": "Préparation du matériel en cours…",
        "materialError": "Le matériel n'a pas pu être créé. Veuillez réessayer.",
        "openMaterial": "Ouvrir le matériel",
        "downloadPresentation": "Télécharger la présentation",
        "createPresentation": "Créer un exposé",
        "createProject": "Créer un projet 🤓",
        "projectGenerating": "Création du projet…",
        "openProject": "Ouvrir le projet",
        "projectError": "Le projet n'a pas pu être créé. Veuillez réessayer.",
        "projectClassTypeOnetimeError": "Aucun autre projet ne peut être créé dans une salle de classe de 24 heures.",
        "inProject": "Dans le projet",
        "instructionsModal": {
          "material": {
            "title": "Créer {material} pour « {phase} »",
            "description": "Les objectifs d'apprentissage, le groupe cible, le contenu de la phase et la forme d'action sont transmis automatiquement.",
            "help": "Facultatif : étendue, niveau de difficulté, format de tâche ou différenciation."
          },
          "placeholder": "Ajouter d'autres consignes…"
        },
        "materialKinds": {
          "assistant": "Assistant IA",
          "classroom_screen": "Écran de la salle de classe",
          "pinboard": "Tableau d'affichage",
          "survey": "Sondage",
          "text_document": "Document texte",
          "web_page": "Site web",
          "word_cloud": "Nuage de mots",
          "worksheet": "Fiche d'exercices",
          "to_teach_worksheet": "Fiche d'exercices (to-teach)",
          "to_teach_presentation": "Présentation (to-teach)"
        }
      },
      "eventDetails": {
        "headlineLesson": "Planifier une leçon",
        "headlineOther": "Planifier un rendez-vous",
        "cardHeadlineOther": "Autre rendez-vous",
        "backLink": "Aperçu de l'emploi du temps",
        "saved": "Modifications enregistrées",
        "form": {
          "titlePlaceholderLesson": "Entrer le sujet de la leçon",
          "titlePlaceholderOther": "Entrer le titre",
          "titleLabel": "Titre",
          "notesLabel": "Notes",
          "notesPlaceholder": "Planifier une leçon",
          "notesPlaceholderOther": "Planifier un rendez-vous",
          "materialsLabel": "Matériaux",
          "projectsLabel": "Projets",
          "attachProjectButton": "Ajouter un projet",
          "dropzoneHint": "Glisser-déposer ici ou",
          "dropzoneSelectFile": "Choisir un fichier",
          "lessonTopicLabel": "Contenu du cours",
          "lessonTopicPlaceholder": "Ici, vous pouvez résumer le contenu du cours à partir des sections ci-dessus à l'aide de l'IA.",
          "lessonTopicHint": "Vous pouvez utiliser l'IA pour résumer le cours. Sélectionnez les contenus à utiliser.",
          "summarizeButton": "Résumer le cours",
          "summarizeAgainButton": "Résumer à nouveau le cours",
          "summarizingButton": "Résumé en cours…",
          "syncToUntisButton": "Transférer vers WebUntis",
          "summarizeError": "Erreur lors du résumé du cours",
          "syncSuccess": "Contenu du cours synchronisé vers WebUntis",
          "syncError": "Échec de la synchronisation vers WebUntis"
        },
        "addContent": {
          "button": "Ajouter du contenu",
          "dialogTitle": "Ajouter du contenu",
          "searchPlaceholder": "Mot-clé...",
          "confirm": "Ajouter",
          "myContentTab": "Mon espace de stockage",
          "toTeachTab": "to teach",
          "toTeachAttachFailed": "La fiche d'exercices se trouve dans votre espace de stockage, mais n'a pas pu être ajoutée à la leçon."
        },
        "materialsError": "Erreur lors de l'enregistrement des matériaux",
        "discontinueCourse": "Terminer le cours",
        "discontinueSeries": "Terminer la série de rendez-vous",
        "previousEvent": "Heure précédente",
        "nextEvent": "Heure suivante",
        "cancelledLabel": "Annulé",
        "cancelledNoticeTitleLesson": "Ce cours est annulé.",
        "cancelledNoticeTitleOther": "Ce rendez-vous est annulé.",
        "cancelledNoticeDescription": "Toutes les informations sont conservées et peuvent être réutilisées ultérieurement."
      },
      "discontinueCourse": {
        "lesson": {
          "title": "Terminer le cours ?",
          "message": "Si vous terminez le cours, ce rendez-vous et tous les rendez-vous suivants du cours seront annulés.",
          "description": "Voulez-vous vraiment annuler tous les {count} rendez-vous suivants de ce cours ?",
          "confirm": "Oui, terminer"
        },
        "other": {
          "title": "Terminer la série de rendez-vous ?",
          "message": "Si vous terminez la série de rendez-vous, ce rendez-vous et tous les rendez-vous suivants de la série seront annulés.",
          "description": "Voulez-vous vraiment annuler tous les {count} rendez-vous suivants de cette série ?",
          "confirm": "Oui, terminer"
        },
        "successMessage": "Cours terminé avec succès",
        "errorMessage": "Erreur lors de la fin du cours"
      },
      "cancelEvent": {
        "lesson": {
          "title": "Annuler la leçon ?",
          "message": "Cette leçon sera supprimée de votre calendrier.",
          "confirm": "Oui, annuler",
          "buttonLabel": "Leçon annulée"
        },
        "other": {
          "title": "Annuler le rendez-vous ?",
          "message": "Ce rendez-vous sera supprimé de votre calendrier.",
          "confirm": "Oui, annuler",
          "buttonLabel": "Rendez-vous annulé"
        },
        "successMessage": "Rendez-vous annulé avec succès",
        "errorMessage": "Erreur lors de l'annulation du rendez-vous"
      },
      "restoreEvent": {
        "lesson": {
          "buttonLabel": "Restaurer le cours"
        },
        "other": {
          "buttonLabel": "Restaurer le rendez-vous"
        },
        "successMessage": "Le rendez-vous a été restauré",
        "errorMessage": "Erreur lors de la restauration du rendez-vous"
      },
      "linkClassroom": {
        "title": "Lier la salle de classe à ce cours",
        "labelTooltip": "Liez une salle de classe numérique pour ce groupe d'apprentissage à ce cours. Vous pourrez ainsi créer facilement des projets et partager plus facilement des contenus avec votre groupe d'apprentissage.",
        "selectPlaceholder": "Sélectionner",
        "confirm": "Lier",
        "cancel": "Annuler",
        "success": "Salle de classe liée avec succès",
        "error": "Erreur lors de la liaison de la salle de classe",
        "buttonLabel": "Lier la salle de classe"
      },
      "attachProject": {
        "title": "Ajouter un projet à la leçon",
        "selectLabel": "Projets de {schoolClassName}",
        "selectPlaceholder": "Sélectionner",
        "newProject": "Nouveau projet",
        "confirm": "Ajouter",
        "cancel": "Annuler",
        "error": "Erreur lors de l'ajout du projet"
      },
      "untisImportTeaser": {
        "text": "Votre école utilise WebUntis ? Vous pouvez alors importer facilement votre emploi du temps. Plus d'informations ici :"
      },
      "untisSyncWarning": {
        "title": "Attention",
        "body": "Seul le « {highlight} » sera transféré vers WebUntis — tous les autres contenus restent dans fobizz.",
        "bodyHighlight": "Résumé du contenu de cours",
        "callout": "Le contenu existant dans le champ « Contenu de cours » dans WebUntis sera écrasé.",
        "confirmButton": "Ok, compris",
        "cancelButton": "Annuler",
        "dontShowAgain": "Ne plus afficher ce message"
      },
      "trialModal": {
        "title": "Ton cadeau : 30 jours fobizz Pro",
        "intro": "Tu viens de connecter ton emploi du temps Untis avec fobizz — heureux de te voir ici !",
        "body": "Pour que tu puisses bien essayer fobizz, nous t'offrons 30 jours Pro : {highlight}.",
        "bodyHighlight": "Chat IA, création de matériel et toutes les formations",
        "cancellation": "Tu n'as pas besoin de résilier — ta période d'essai se termine automatiquement. Ton emploi du temps reste et se synchronise avec WebUntis.",
        "email": "Nous t'envoyons aussi les détails par e-mail.",
        "confirmButton": "Vers l'emploi du temps"
      }
    }
  }
}
